import React from 'react'
import { CommonPublisherPhoneNumberFieldEntityOrSubEntity } from 'src/publisher/shared/components/field/common-publisher-phone-number-field-entity-or-sub-entity'
import { FormFieldInterface } from 'src/shared/entities/form/form-field-sub-entity.schema'
import { useFormField } from '../hooks/use-form-field'

interface FormPhoneNumberFieldSubEntityProps {
  fieldSubEntity: FormFieldInterface
}

export const FormPhoneNumberFieldSubEntity = ({
  fieldSubEntity,
}: FormPhoneNumberFieldSubEntityProps) => {
  const { value, onChange, errors } = useFormField({
    fieldSubEntity,
  })
  return (
    <CommonPublisherPhoneNumberFieldEntityOrSubEntity
      entityOrSubEntity={fieldSubEntity}
      value={value}
      onChange={onChange}
      errors={errors}
    />
  )
}
